import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import ExistingFactoryDescForm from "./ExistingFactoryDescForm";
import "../../CSS/Grid.css"

class PopUp extends Component{


    handleSaveDetails=()=>{
        this.props.handleSaveDetails()
    }


    render() {

        const {
            queryParams,
            selectedFactoryJson,
            isPickupMode,
            newFactory,
            transaction_type
        }=this.props
          //console.log("isPickupMode: ",isPickupMode,"transaction_type: ",transaction_type)
          const isImporter = transaction_type === 'Importer';
          const from = queryParams.from;
          const to = queryParams.to;
  
          const portsJSON = isImporter
          ? (isPickupMode ? from : to)
          : (isPickupMode ? to : from);
  
          const myCountries = isImporter
          ? (isPickupMode ? from.country : to.country)
          : (isPickupMode ? to.country : from.country);
        return(
            <div>
                <div className="success-popup">

                    <div className="success-message select-shipper-popup">
                        {isPickupMode?(
                            <>
                               <b>Select Shipper</b>
                            </>
                        ):(
                            <>
                                <b>Select Factory</b>
                            </>
                        )}
                        <ExistingFactoryDescForm
                            portsJSON={portsJSON}
                            myCountries={myCountries}
                            selectedFactoryJson={selectedFactoryJson}
                            handleSelectExistingNewPort={this.handleSelectExistingNewPort}
                            isPickupMode={isPickupMode}
                            new_factory={newFactory}
                        />
                        <button className="ok-button" onClick={()=>this.handleSaveDetails()}>Close</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps=(state)=>{
    return{
        originPortJSON:state.route.originPortJSON.Ports,
        transaction_type: state.code_config.transactionType,
    }
}

export default connect(mapStateToProps, actions)(PopUp);
